import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

/** Small dropdown anchored to a trigger — closes on outside click. */
export default function AnchoredDropdown({ trigger, children }) {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState(null);
  const triggerRef = useRef(null);
  const menuRef = useRef(null);
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (triggerRef.current && triggerRef.current.contains(e.target)) return;
      if (menuRef.current && menuRef.current.contains(e.target)) return;
      setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  // The menu is rendered in a portal with fixed positioning so it is never
  // clipped by an ancestor's overflow (e.g. the MetaCell's `truncate`) or
  // trapped under another stacking context — the old absolute menu opened but
  // was invisible inside the run popup.
  const toggle = () => {
    setOpen((v) => {
      const next = !v;
      if (next && triggerRef.current) {
        const r = triggerRef.current.getBoundingClientRect();
        setPos({ top: r.bottom + 4, left: r.left });
      }
      return next;
    });
  };

  return (
    <div className="relative inline-block" ref={triggerRef}>
      <div onClick={toggle}>{trigger}</div>
      {open && pos && createPortal(
        <div
          ref={menuRef}
          onClick={() => setOpen(false)}
          className="fixed z-[100] min-w-[200px] rounded-lg border border-[color:var(--border-default)] bg-surface py-1 shadow-xl"
          style={{ top: pos.top, left: pos.left, fontFamily: 'Inter, sans-serif' }}
        >
          {children}
        </div>,
        document.body,
      )}
    </div>
  );
}
